// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file.
console.log('This site was developed by https://www.sleeplessmedia.com');

(function ($) {
	$(window).ready(function () {
		//Knockout Code
		var ViewModel = function ViewModel() {
			self = this; //PDP Observables

			if (meta.pageType == 'product') {
				this.pdp_option1_selected = ko.observable('');
				this.pdp_option2_selected = ko.observable('');
				this.pdp_option3_selected = ko.observable('');
				this.pdp_color_selected = ko.observable('');
				this.pdp_quantity_selected = ko.observable(1);
				this.pdp_product_data = ko.observable({});
				this.pdp_thumbs_array = ko.observableArray([]);
				this.pdp_thumbs_visible = ko.observableArray([]);
				this.pdp_variants_meta = ko.observableArray(
					meta.product.variants || []
				);
				this.pdp_active_possibilities = ko.observableArray([]);
				this.pdp_active_option = ko.observable(1); //PDP Functions

				this.pdp_variant_selected_title = ko.computed(function () {
					return ''
						.concat(this.pdp_option1_selected(), ' / ')
						.concat(this.pdp_option2_selected(), ' / ')
						.concat(this.pdp_option3_selected());
				}, this); //Reach out from each control input and make sure the
				//input's value is possible given the

				this.pdp_variant_selected_id = ko.computed(function () {
					var _this = this;

					var id = null;
					this.pdp_variants_meta().forEach(function (element) {
						if (
							element.public_title ==
							_this.pdp_variant_selected_title()
						) {
							id = element.id;
						}
					});

					if (id) {
						return id;
					}
				}, this);

				this.match_with_images = function (color, option) {
					if (option == 1) {
						self.pdp_option1_selected(color);
					}

					if (option == 2) {
						self.pdp_option2_selected(color);
					}

					if (option == 3) {
						self.pdp_option3_selected(color);
					}

					var arr = self.pdp_thumbs_array();
					color = color.replace(' ', '-');
					self.pdp_thumbs_visible([]);
					arr.forEach(function (el, index) {
						if (el.toLowerCase().includes(color.toLowerCase())) {
							self.pdp_thumbs_visible.push(el);
						}
					});
				};

				this.pdp_selected_contains_me = function (
					data,
					option_number,
					value
				) {
					if (option_number != self.pdp_active_option()) {
						return self
							.pdp_active_possibilities()
							.toString()
							.includes(value);
					} else {
						return true;
					}
				};

				this.pdp_option1_value_possibilites = ko.computed(function () {
					var _this2 = this;

					var arr = [];
					this.pdp_variants_meta().forEach(function (variant) {
						if (
							variant.public_title.includes(
								_this2.pdp_option1_selected()
							)
						) {
							arr.push(variant.public_title);
						}
					});
					this.pdp_active_option(1);
					this.pdp_active_possibilities(arr);
				}, this);
				this.pdp_option2_value_possibilites = ko.computed(function () {
					var _this3 = this;

					var arr = [];
					this.pdp_variants_meta().forEach(function (variant) {
						if (
							variant.public_title.includes(
								_this3.pdp_option2_selected()
							)
						) {
							arr.push(variant.public_title);
						}
					});
					this.pdp_active_option(2);
					this.pdp_active_possibilities(arr);
				}, this);
				this.pdp_option3_value_possibilites = ko.computed(function () {
					var _this4 = this;

					var arr = [];
					this.pdp_variants_meta().forEach(function (variant) {
						if (
							variant.public_title.includes(
								_this4.pdp_option3_selected()
							)
						) {
							arr.push(variant.public_title);
						}
					});
					this.pdp_active_option(3);
					this.pdp_active_possibilities(arr);
				}, this);

				this.pdp_increment = function () {
					self.pdp_quantity_selected(
						parseInt(self.pdp_quantity_selected() + 1)
					);
				};

				this.pdp_decrement = function () {
					if (self.pdp_quantity_selected() > 1) {
						self.pdp_quantity_selected(
							parseInt(self.pdp_quantity_selected() - 1)
						);
					}
				};
			} //Cart Observables

			this.articles = ko.observableArray([]);
			this.item_count = ko.observable(CartJS.cart.item_count);
			this.total_price = ko.observable(CartJS.cart.total_price);
			this.items = ko.observableArray(CartJS.cart.items);
			this.variant_id = ko.observable(0); //Cart Functions

			this.toDollars = function (num) {
				return '$' + (parseInt(num) / 100).toFixed(2);
			};

			this.clearCart = function () {
				CartJS.clear();
			};

			this.addItem = function (variantId, quantity) {
				CartJS.addItem(variantId, quantity, {}, {});
			};

			this.removeItem = function (variantId) {
				CartJS.removeItemById(variantId);
			};

			this.increment = function (line_number, quantity) {
				quantity = parseInt(quantity + 1);
				CartJS.updateItem(
					line_number + 1,
					quantity,
					{},
					{
						success: function success(data, textStatus, jqXHR) {
							if (data.items[line_number].quantity < quantity) {
								console.log(
									'The requested quantity for this item is not available.'
								);
							}
						},
						error: function error(jqXHR, textStatus, errorThrown) {
							console.error('Error: ' + errorThrown + '!');
						},
					}
				);
			};

			this.decrement = function (line_number, quantity) {
				if (quantity > 1) {
					quantity = parseInt(quantity - 1);
					CartJS.updateItem(
						line_number + 1,
						quantity,
						{},
						{
							success: function success(data, textStatus, jqXHR) {
								if (
									data.items[line_number].quantity < quantity
								) {
									console.log(
										'The requested quantity for this item is not available.'
									);
								}
							},
							error: function error(
								jqXHR,
								textStatus,
								errorThrown
							) {
								console.error('Error: ' + errorThrown + '!');
							},
						}
					);
				}
			};

			this.removeItem = function (line_number) {
				CartJS.updateItem(
					line_number + 1,
					0,
					{},
					{
						success: function success(data, textStatus, jqXHR) {
							console.info('Item removed from cart.');
						},
						error: function error(jqXHR, textStatus, errorThrown) {
							console.error('Error: ' + errorThrown + '!');
						},
					}
				);
			};

			this.enterQuantity = function (line_number, quantity, item, event) {
				var self = this;

				if (quantity >= 1) {
					CartJS.updateItem(
						line_number,
						quantity,
						{},
						{
							success: function success(
								data,
								textStatus,
								jqXHR
							) {},
							error: function error(
								jqXHR,
								textStatus,
								errorThrown
							) {
								console.error('Error: ' + errorThrown + '!');
							},
						}
					);
				}
			};

			this.sortArticlesBy = function (tag) {
				var result = self.articles().filter(function (element) {
					return element.tags.includes(tag) ? true : false;
				});
				self.articles(result);
			};
		};

		ko.bindingHandlers.enterkey = {
			//this is not just an enterkey binding. It is specifically for the qty control
			init: function init(
				element,
				valueAccessor,
				allBindings,
				viewModel,
				bindingContext
			) {
				var callback = valueAccessor();
				$(element).keypress(function (event) {
					var keyCode = event.which ? event.which : event.keyCode;

					if (keyCode === 13) {
						callback.call(
							bindingContext.$data,
							parseInt(bindingContext.$index() + 1),
							parseInt(element.value)
						);
						return false;
					}

					return true;
				});
			},
		};
		ko.applyBindings(new ViewModel()); //Everytime a request to CartJS is finished, sync the view model with CartJS.

		$(document).on('cart.requestComplete', function (event, cart) {
			ko.dataFor(document.body).items(CartJS.cart.items);
			ko.dataFor(document.body).total_price(CartJS.cart.total_price);
			ko.dataFor(document.body).item_count(CartJS.cart.item_count);
		}); //End Knockout Code
		// Let the document know when the mouse is being used

		document.body.addEventListener('mousedown', function () {
			document.body.classList.add('using-mouse');
		});
		document.body.addEventListener('keydown', function () {
			document.body.classList.remove('using-mouse');
		}); // Let the document know when page is scrolled.

		$(window).on('scroll load', function (event) {
			if ($(document).scrollTop() > 30) {
				$('body').addClass('scrolled');
			} else {
				$('body').removeClass('scrolled');
			}
		});
		$('.header__dropWrapper').on('click', function () {
			if ($(this).hasClass('header__dropWrapper--hover')) {
				$(this).removeClass('header__dropWrapper--hover');
			} else {
				$('.header__dropWrapper--hover').removeClass(
					'header__dropWrapper--hover'
				);
				$(this).addClass('header__dropWrapper--hover');

				if ($('.searchBar').is(':visible')) {
					$('.searchBar').slideUp();
					$('.mobileMenu__overlay').fadeOut();
				}

				if ($('.miniCart').is(':visible')) {
					$('.miniCart').slideUp();
					$('.mobileMenu__overlay').fadeOut();
				}
			}
		});
		$(document).on('click', function (event) {
			if (!$(event.target).closest('.header__dropWrapper').length) {
				$('.header__dropWrapper--hover').removeClass(
					'header__dropWrapper--hover'
				);
			}
		});

		$('.header__searchButton').on('click', function () {
			if ($('.searchBar').is(':visible')) {
				$('.searchBar').slideUp();
				$('.mobileMenu__overlay').fadeOut();
			} else {
				$('.searchBar').slideDown();
				$('.mobileMenu__overlay').fadeIn();
				$('.header__dropWrapper--hover').removeClass(
					'header__dropWrapper--hover'
				);

				if ($('.miniCart').is(':visible')) {
					$('.miniCart').slideUp();
					$('.mobileMenu__overlay').fadeOut();
				}
			}
		});
		$('.header__cartButton').on('click', function () {
			if ($('.mobileMenu').is(':visible')) {
				$('.mobileMenu').slideUp();
				$('.header__burger').removeClass('header__burger--open');
				setTimeout(function () {
					$('.miniCart').slideDown();
				}, 500);
			} else {
				if ($('.miniCart').is(':visible')) {
					$('.miniCart').slideUp();
					$('.mobileMenu__overlay').fadeOut();
				} else {
					$('.miniCart').slideDown();
					$('.mobileMenu__overlay').fadeIn();
					$('.header__dropWrapper--hover').removeClass(
						'header__dropWrapper--hover'
					);

					if ($('.searchBar').is(':visible')) {
						$('.searchBar').slideUp();
					}
				}
			}
		});
		$('.header__burger').on('click', function () {
			if ($('.miniCart').is(':visible')) {
				$('.miniCart').slideUp();
				setTimeout(function () {
					$('.mobileMenu').slideDown();
				}, 500);
			} else {
				if ($('.mobileMenu').is(':visible')) {
					$('.mobileMenu').slideUp();
					$('.mobileMenu__overlay').fadeOut();
					$('.header__burger').removeClass('header__burger--open');
					$('.header').removeClass('header--menuOpen');
				} else {
					$('.mobileMenu').slideDown();
					$('.mobileMenu__overlay').fadeIn();
					$('.header__burger').addClass('header__burger--open');
					$('.header').addClass('header--menuOpen');
				}
			}
		});
		$('.mobileMenu__close').on('click', function () {
			$('.mobileMenu').slideUp();
			$('.mobileMenu__overlay').fadeOut();
			$('.header__burger').removeClass('header__burger--open');
			$('.header').removeClass('header--menuOpen');
		});
		$('.mobileMenu__masterDropTitle').on('click', function () {
			var parent = $(this).parent();
			var content = parent.find('.mobileMenu__masterDropInner');

			if (content.is(':visible')) {
				content.slideUp();
				parent.removeClass('mobileMenu__masterDrop--open');
			} else {
				$('.mobileMenu__masterDropInner').slideUp();
				$('.mobileMenu__masterDrop').removeClass(
					'mobileMenu__masterDrop--open'
				);
				content.slideDown();
				parent.addClass('mobileMenu__masterDrop--open');
			}
		});
		$(window).resize(function () {
			$('.mobileMenu').slideUp();
			$('.mobileMenu__overlay').fadeOut();
			$('.header__burger').removeClass('header__burger--open');
		});
		$('.mobileMenu__childDropTitle').on('click', function () {
			var parent = $(this).parent();
			var content = parent.find('.mobileMenu__childDropInner');

			if (content.is(':visible')) {
				content.slideUp();
				parent.removeClass('mobileMenu__childDrop--open');
			} else {
				$('.mobileMenu__childDropInner').slideUp();
				$('.mobileMenu__childDrop').removeClass(
					'mobileMenu__childDrop--open'
				);
				content.slideDown();
				parent.addClass('mobileMenu__childDrop--open');
			}
		});
		$('.mobileMenu__lookingGlass').on('click', function () {
			if ($('.mobileMenu__searchForm').is(':visible')) {
				$('.mobileMenu__searchForm').slideUp();
				$('.mobileMenu__lookingGlass').removeClass(
					'mobileMenu__lookingGlass--open'
				);
			} else {
				$('.mobileMenu__searchForm').slideDown();
				$('.mobileMenu__searchInput').focus();
				$('.mobileMenu__lookingGlass').addClass(
					'mobileMenu__lookingGlass--open'
				);
			}
		});
		$('.collection__sortDrop--inner').on('change', function () {
			window.location.href = $('.collection__sortDrop--inner').val();
		});

		if ($('#compare').text().trim() == '$ 0.00') {
			$('#compare').hide();
		}

		$('#variantDrop').on('change', function () {
			var index = $(this).val();
			index = index * 1;
			var newObj = variants[index];
			$(this)
				.parent()
				.parent()
				.find('#compare')
				.text(newObj.compare_price);
			$(this).parent().parent().find('#price').text(newObj.price);
			$('#price--mobile').text(newObj.price);

			if ($('#compare').text().trim() === '$ 0.00') {
				$('#compare').hide();
			} else {
				$('#compare').show();
			}
		});
		var ready = true;
		var buffer = '';
		$('#buyButton').on('click', function () {
			var index = $('#variantDrop').val();
			index = index * 1;
			var newObj = variants[index];
			var qty = $('#quantity').val();

			if (ready == true) {
				ready = false;
				buffer = $('#buyButton').text();
				$('#buyButton').text('Adding...');
				CartJS.addItem(
					newObj.id,
					qty,
					{},
					{
						success: function success(data, textStatus, jqXHR) {
							if ($('.mobileMenu').is(':visible')) {
							} else {
								if ($('.miniCart').is(':visible')) {
									$('.miniCart').slideUp();
									$('.mobileMenu__overlay').fadeOut();
								} else {
									$('.miniCart').slideDown();
									$('.mobileMenu__overlay').fadeIn();
								}
							}

							setTimeout(function () {
								ready = true;
								$('#buyButton').text(buffer);
							}, 500);
						},
						error: function error(jqXHR, textStatus, errorThrown) {
							alert('Error: ' + errorThrown + '!');
							setTimeout(function () {
								ready = true;
								$('#buyButton').text(buffer);
							}, 500);
						},
					}
				);
			}
		});
		$('.mobileMenu__overlay').on('click', function () {
			$('.miniCart').slideUp();
			$('.mobileMenu').slideUp();
			$('.mobileMenu__overlay').fadeOut();
			$('.header__burger').removeClass('header__burger--open');
			$('.header').removeClass('header--menuOpen');
		});
		$('.productHead__imgGalleryInner').slick({
			dots: true,
			infinite: true,
			speed: 500,
			fade: true,
			arrows: false,
			cssEase: 'linear',
		});
		$('.dvd__faqTitle').on('click', function () {
			var parent = $(this).parent();
			var content = parent.find('.dvd__faqDesc');

			if (content.is(':visible')) {
				content.slideUp();
				parent.removeClass('dvd__faqWrapper--open');
			} else {
				$('.dvd__faqDesc').slideUp();
				$('.dvd__faqWrapper').removeClass('dvd__faqWrapper--open');
				content.slideDown();
				parent.addClass('dvd__faqWrapper--open');
			}
		});
		$('[question]').on('click', function () {
			var parent = $(this).parent();
			var content = parent.find('[answer]');

			if (content.is(':visible')) {
				content.slideUp();
				parent.removeClass('--open');
			} else {
				$('[answer]').slideUp();
				$('--open').removeClass('--open');
				content.slideDown();
				parent.addClass('--open');
			}
		});
		$('[href]').each(function () {
			if ($(this).attr('href').indexOf('uscreen') >= 0) {
				$(this).attr('target', '_blank');
			}
		});
		function preload(arrayOfImages) {
			$(arrayOfImages).each(function () {
				$('<img/>')[0].src = this;
				// Alternatively you could use:
				// (new Image()).src = this;
			});
		}

		var preloadArray = [];

		$('.dvd__select')
			.find('option')
			.each(function () {
				preloadArray.push($(this).attr('src'));
			});

		preload(preloadArray);

		$('.dvd__select').on('change', function () {
			var newSrc = $(this).find('option:selected').attr('imgsrc');
			console.log(newSrc);
			$('.dvd__featuredImg').attr('src', newSrc);
		});

		document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
			anchor.addEventListener('click', function (e) {
				e.preventDefault();
				document
					.querySelector(this.getAttribute('href'))
					.scrollIntoView({
						behavior: 'smooth',
					});
			});
		});

		// The header is position:fixed, so #MainContent needs matching padding-top
		// or content sits underneath it. The announcement bar (sections/announcement-bar.liquid)
		// is fixed above the header and can be dismissed, so its live height is read from the
		// --hs-ab-h CSS var it maintains (0px once closed) rather than re-measured here.
		function setMainContentPadding() {
			var headerHeight = $('.header').outerHeight() || 0;
			var announcementHeight =
				parseInt(
					getComputedStyle(document.documentElement).getPropertyValue(
						'--hs-ab-h'
					),
					10
				) || 0;
			$('#MainContent').css(
				'padding-top',
				headerHeight + announcementHeight + 'px'
			);
		}

		setMainContentPadding();
		$(window).on('load resize', setMainContentPadding);
		$(document).on('click', '.hs-ab__close', setMainContentPadding);
	});
})(jQuery);
//Sleepify Starter Theme by Sleepless Media
//This file is intended to be used for small ongoing fixes or changes post-launch.
